class BuildTags {
}
/** Hash the last time inertia was built */
BuildTags.buildHash = '8f7773aa';
/** Version of the package.json file the last time inertia was built */
BuildTags.packageVersion = '1185.0.9';
/** Time inertia was built in UTC */
BuildTags.buildTime = 'Wed, 05 Aug 2026 13:54:00 GMT';
/** Time inertia was built in Boston time */
BuildTags.buildTimeBoston = '2026-08-05 09:54:28 Boston';
/** Detailed build tags string */
BuildTags.detailed = 'BuildTags: 2026-08-05 09:54:28 Boston - 8f7773aa - 1185.0.9';
export default BuildTags;
